import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import SearchPage from "@/pages/SearchPage";
import VerifyPage from "@/pages/VerifyPage";
import EditionPage from "@/pages/EditionPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminEdicoes from "@/pages/admin/AdminEdicoes";
import AdminUsuarios from "@/pages/admin/AdminUsuarios";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminBackup from "@/pages/admin/AdminBackup";
import AdminCertificados from "@/pages/admin/AdminCertificados";

// PWA Components
import PWAInstallPrompt, { OfflineBanner } from "@/components/PWAInstall";

function App() {
  return (
    <div className="App min-h-screen bg-[#F9FAFB]">
      <OfflineBanner />
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/buscar" element={<SearchPage />} />
          <Route path="/verificar" element={<VerifyPage />} />
          <Route path="/edicao/:edicaoId" element={<EditionPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/edicoes" element={<AdminEdicoes />} />
          <Route path="/admin/usuarios" element={<AdminUsuarios />} />
          <Route path="/admin/newsletter" element={<AdminNewsletter />} />
          <Route path="/admin/backup" element={<AdminBackup />} />
          <Route path="/admin/certificados" element={<AdminCertificados />} />
        </Routes>
      </BrowserRouter>
      <PWAInstallPrompt />
    </div>
  );
}

export default App;
